'use client'
import {
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'

import {
  NormalizedSection,
  OpeningTitleProps,
  ParagraphProps,
  TitleProps,
} from '@/types'

import BubbleCluster, {
  BubbleContent,
} from '@/components/molecules/BubbleCluster'

export interface PartnersProps extends NormalizedSection {
  modelledContent: {
    openingTitle: OpeningTitleProps
    title: TitleProps
    paragraph: ParagraphProps
    bubbleCluster: BubbleContent[]
  }
  props: {
    preview: boolean
    bubbleSize: 'small' | 'medium' | 'big'
  }
}

const PartnersSection = ({ modelledContent, props }: PartnersProps) => {
  const { openingTitle, title, paragraph, bubbleCluster } = modelledContent
  const { bubbleSize, preview } = props
  return (
    <Section className='section-partners'>
      <div className='section-partners__content'>
        <div className='section-header'>
          <OpeningTitle {...openingTitle}>{openingTitle.content}</OpeningTitle>
          <Title
            {...title}
            dangerouslySetInnerHTML={{ __html: title.content || '' }}
          />
          <Paragraph
            as={'div'}
            {...paragraph}
            dangerouslySetInnerHTML={{ __html: paragraph?.content || '' }}
          />
        </div>
        {!!bubbleCluster && !!bubbleCluster.length && (
          <div className='section-content'>
            <BubbleCluster
              content={bubbleCluster}
              preview={preview}
              bubbleSize={bubbleSize}
              isPartner={true}
            />
          </div>
        )}
      </div>
    </Section>
  )
}

export default PartnersSection
